import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostSaveWordCloud = (id_ean: string, temp_url: string) => {
  return apiInstance.post(ApiPathConfig.SAVE_WORD_CLOUD(id_ean), { temp_url })
}

export default PostSaveWordCloud
